import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ModalsService} from "../../services/modals.service";
import {Melody} from "../../model/melody";
import {SubscriberService} from "../../services/subscriber.service";
import {SubscriptionStatus} from "../../model/subscription-status";
import {Subscription} from "rxjs";
import {SubscriberMelody} from "../../model/subscriber-melody";
import {ContentStatus} from "../../model/content-status";

@Component({
  selector: 'app-purchase-melody-modal',
  templateUrl: './purchase-melody-modal.component.html',
  styleUrls: ['./purchase-melody-modal.component.css']
})
export class PurchaseMelodyModalComponent implements OnInit, OnDestroy {
  @Input() melody: Melody;

  privetPlusPurchase: boolean;
  privetPlusConfirmation: boolean;
  purchasing: boolean;
  melodiesNumber: number;
  tooManyMelodiesError: boolean;
  wrongServiceError: boolean;
  requestInProgress: boolean;
  privet: boolean;
  privetPlus: boolean;
  subscription: Subscription;
  promo: boolean;
  isDataLoaded: boolean = false;

  constructor(private readonly modalsService: ModalsService,
              private readonly subscriberService: SubscriberService) {

    this.privetPlusPurchase = true;
    this.privetPlusConfirmation = false;
    this.purchasing = false;
    this.melodiesNumber = 1;
    this.privet = false;
    this.privetPlus = false;
    this.subscription = new Subscription();
  }

  ngOnInit(): void {
    this.subscription.add(
    this.subscriberService.subscriber.subscribe(subscriber => {
      this.privet = subscriber.privetStatus == SubscriptionStatus.ACTIVE || subscriber.privetStatus == SubscriptionStatus.ACTIVATING;
      this.privetPlus = subscriber.privetPlusStatus == SubscriptionStatus.ACTIVE || subscriber.privetPlusStatus == SubscriptionStatus.ACTIVATING;
      this.isDataLoaded = true;
    }));

    this.subscription.add(
      this.subscriberService.subscriberMelodies.subscribe((melodies: ReadonlyArray<SubscriberMelody>) => {
        this.checkSubscriberMelodies(melodies as SubscriberMelody[]);
      })
    );
  }

  close(): void {
    this.modalsService.hideModal();
  }

  purchaseMelody(): void {
    const isPrivetPlusSelected = this.privetPlus || (!this.privet && !this.privetPlus && this.privetPlusPurchase);
    if (isPrivetPlusSelected) {
      this.purchaseMelodyWithPrivetPlus();
    } else {
      this.purchaseMelodyWithPrivet();
    }
  }

  purchaseMelodyWithPrivetPlus(): void {
    this.purchasing = true;
    this.privetPlusPurchase = true;
    this.requestInProgress = true;
    this.subscriberService.purchaseMelody(this.melody, true, (status) => {
      this.checkErrors(status)
      this.requestInProgress = false;
    });
  }

  purchaseMelodyWithPrivet(): void {
    this.purchasing = true;
    this.privetPlusPurchase = false;
    this.requestInProgress = true;

    this.subscriberService.purchaseMelody(this.melody, false, (status) => {
      this.checkErrors(status);
      this.requestInProgress = false;
    });
  }

  private checkErrors(status: string) {
    switch (status) {
      case 'TOO_MANY_MELODIES' :
        this.tooManyMelodiesError = true;
        break;
      case 'WRONG_SERVICE' :
        this.wrongServiceError = true;
        break
      default:

        break;
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  togglePlan(selectPrivetPlus: boolean) {
    if (this.privet || this.privetPlus) {
      this.privetPlusPurchase = selectPrivetPlus;
      this.privet = !selectPrivetPlus
      this.privetPlus = selectPrivetPlus;
    } else {
      this.privetPlusPurchase = !this.privetPlusPurchase;
    }
  }

  private checkSubscriberMelodies(melodies: ReadonlyArray<SubscriberMelody>): void {
    const activeMelody = melodies?.find(m => m.contentStatus === ContentStatus.ACTIVE) ?? melodies?.[0];
    this.promo = activeMelody?.tariffType === 'PROMO';
  }
}
